// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1sDPw","buttons":"RemoveExpirationActionButtons_buttons__RrknO"};